<template>
    <span>Welcome to <b>BST</b></span>
</template>
<script>
  export default {
    name: 'notification-sample'
  }
</script>
<style>
</style>
